import { CrudMode, FormItem, SelectsOptions } from '@ohpen/enso-ui';
import { FieldType } from '@pmp/api';

export const getFormSchema = (selectsOptions: SelectsOptions, mode?: CrudMode | null): FormItem[] => [
  {
    title: 'global.labels.category',
    dataIndex: 'category',
    valueType: 'select',
    formItemProps: {
      rules: [{ required: true }],
    },
    fieldProps: {
      options: selectsOptions[FieldType.NOTE_CATEGORY],
    },
  },
  {
    title: 'global.labels.note',
    dataIndex: 'text',
    valueType: 'textarea',
    formItemProps: {
      rules: [{ required: true }],
    },
  },
];
